import require$$0 from '@wix/draft-js';

var addMention$1 = {};

var getSearchText = {};

var getSearchTextAt = {};

Object.defineProperty(getSearchTextAt, "__esModule", {
  value: true
});

/**
 * Return tail end of the string matching trigger upto the position.
 */
getSearchTextAt.default = function (blockText, position, trigger) {
  var str = blockText.substr(0, position);
  var begin = trigger.length === 0 ? 0 : str.lastIndexOf(trigger);
  var matchingString = trigger.length === 0 ? str : str.slice(begin + trigger.length);
  var end = str.length;

  return {
    begin: begin,
    end: end,
    matchingString: matchingString
  };
};

Object.defineProperty(getSearchText, "__esModule", {
  value: true
});

var _getSearchTextAt = getSearchTextAt;

var _getSearchTextAt2 = _interopRequireDefault$1(_getSearchTextAt);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

getSearchText.default = function (editorState, selection, trigger) {
  var anchorKey = selection.getAnchorKey();
  var anchorOffset = selection.getAnchorOffset();
  var currentContent = editorState.getCurrentContent();
  var currentBlock = currentContent.getBlockForKey(anchorKey);
  var blockText = currentBlock.getText();
  return (0, _getSearchTextAt2.default)(blockText, anchorOffset, trigger);
};

var getTypeByTrigger$1 = {};

Object.defineProperty(getTypeByTrigger$1, "__esModule", {
  value: true
});
var getTypeByTrigger = function getTypeByTrigger(trigger) {
  return trigger === '@' ? 'mention' : trigger + 'mention';
};

getTypeByTrigger$1.default = getTypeByTrigger;

Object.defineProperty(addMention$1, "__esModule", {
  value: true
});

var _draftJs = require$$0;

var _getSearchText2 = getSearchText;

var _getSearchText3 = _interopRequireDefault(_getSearchText2);

var _getTypeByTrigger = getTypeByTrigger$1;

var _getTypeByTrigger2 = _interopRequireDefault(_getTypeByTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addMention = function addMention(editorState, mention, mentionPrefix, mentionTrigger, entityMutability) {
  var contentStateWithEntity = editorState.getCurrentContent().createEntity((0, _getTypeByTrigger2.default)(mentionTrigger), entityMutability, {
    mention: mention
  });
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  var currentSelectionState = editorState.getSelection();

  var _getSearchText = (0, _getSearchText3.default)(editorState, currentSelectionState, mentionTrigger),
      begin = _getSearchText.begin,
      end = _getSearchText.end;

  // get selection of the @mention search text


  var mentionTextSelection = currentSelectionState.merge({
    anchorOffset: begin,
    focusOffset: end
  });

  var mentionReplacedContent = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), mentionTextSelection, '' + mentionPrefix + mention.name, null, // no inline style needed
  entityKey);

  // If the mention is inserted at the end, a space is appended right after for
  // a smooth writing experience.
  var blockKey = mentionTextSelection.getAnchorKey();
  var blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength();
  if (blockSize === end) {
    mentionReplacedContent = _draftJs.Modifier.insertText(mentionReplacedContent, mentionReplacedContent.getSelectionAfter(), ' ');
  }

  var newEditorState = _draftJs.EditorState.push(editorState, mentionReplacedContent, 'insert-mention');
  return _draftJs.EditorState.forceSelection(newEditorState, mentionReplacedContent.getSelectionAfter());
};

var _default = addMention$1.default = addMention;

export { _default as _, addMention$1 as a, getTypeByTrigger$1 as b, getSearchText as g };
//# sourceMappingURL=addMention-d507fa95.js.map
